<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.icf list") }}</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="ibox-content py-2 mb-1">
        <div class="d-flex flex-column flex-lg-row justify-content-lg-end my-2 my-lg-0">
          <div class="col-lg-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.form name") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="formName"
              />
            </div>
          </div>
          <div class="col-lg-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.version") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="version"
              />
            </div>
          </div>
          <div class="col-lg-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.language") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="language"
              />
            </div>
          </div>
            <span
            type="button"
              class="col-12 col-lg-3 save_btn w-100 align-self-end"
              @click.prevent="SearchButtonClicked()"
            >
              {{ $t("navigations.search") }}
            </span>            
        </div>
      </div>
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5>{{ $t("navigations.icf list") }}</h5>
          <div class="d-flex" v-if="rollsprivilages.includes('ICF Upload ICF Form')">
            <div class="position-relative align-self-center mr-3">
              <img class="cursor-pointer" src="../../assets/img/create.png" alt="Create ICF" @click.prevent="createICFForm(0)"/>
              <div class="tool-tip">{{ $t("navigations.upload icf form") }}</div>
            </div>
          </div>
        </div>
           
        <div class="ibox-content">
          <div class="text-center" v-if="showLoading === true">
            <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
            <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
          </div>
          <template v-else>
            <div class="text-center" v-if="icfList.length==0">
              {{ $t('navigations.no data available') }}
            </div>
            <div v-else class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                    <th class="sort_block" @click="SortSelected('index', 1)" id="1">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.consent form id") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelected('formName', 2)" id="2">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.form name") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                         
                    <th class="sort_block" @click="SortSelected('uploadedBy', 3)" id="3">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.uploaded by") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelected('uploadedAt', 4)" id="4">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.uploaded date") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelected('effectiveDate', 5)" id="5">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.effective date") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
              
                    <th class="sort_block" @click="SortSelected('versionNumber', 6)" id="6">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.version") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelected('language', 7)" id="7">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.language") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="text-center">{{ $t("navigations.status") }}</th>
                    <th v-if="rollsprivilages.includes('ICF Configuration')" class="text-center">{{ $t("navigations.configuration") }}</th>
                    <th v-if="rollsprivilages.includes('ICF Upload Videos')" class="text-center">{{ $t("navigations.videos") }}</th>

                     <th v-if="rollsprivilages.includes('ICF Delete')" class="text-center">{{ $t("navigations.delete") }}</th>
                     <th v-if="rollsprivilages.includes('ICF View')" class="text-center"> {{ $t("navigations.view") }}</th>
                  </tr>
                </thead>
                <tbody>
                 <tr v-for="(icf, index) in icfList" :key="icf.id">
                    <td>{{ icf.consentFormId }}</td>
                    <td>{{ icf.formName }}</td>
                    <td>{{ icf.uploadedBy?.name || icf.uploadedBy?.userId || '-' }}</td>
                    <td>{{ formatDate(icf.uploadedAt) }}</td>
                    <td>{{ formatDate(icf.effectiveDate) }}</td>
                    <!-- <td>{{ formatDate(icf.CreatedAt) }}</td> -->
                    
                    <td>{{ icf.versionNumber || '-' }}</td>
                    <td>{{ icf.language || '-' }}</td>
                    <td class="text-center">{{ icf.status === 'Active' ? $t('navigations.active') : $t('navigations.inactive') }}</td>
                        <td class="text-center" v-if="rollsprivilages.includes('ICF Configuration')">
                      <i
                        class="fa fa-pencil-square edit-delete cursor-pointer"
                        @click.prevent="openReconsentModal(icf, index)"
                        title="Re-Consent Campaign"
                      ></i>
                    </td>
                  <td class="text-center" v-if="rollsprivilages.includes('ICF Upload Videos')">
                    <i 
                      class="fa fa-file-video-o edit-delete cursor-pointer" 
                      @click.prevent="openvideos(icf.id, icf.formName, icf.versionNumber)"
                      title="Manage ICF Videos"
                    ></i>
                  </td>
                    <td class="text-center" v-if="rollsprivilages.includes('ICF Delete')">
                      <i class="fa fa-trash edit-delete" @click.prevent="deleteICFForm(icf.id)"></i>
                    </td>
                    <td class="text-center" v-if="rollsprivilages.includes('ICF View')">
                      <i v-if="rollsprivilages.includes('ICF View')" class="fa fa-eye edit-delete" @click.prevent="viewICFForm(icf)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="icfList.length!=0">
                <VPagination
                  v-model="currentPage"
                  :pages="totalPages"
                  :range-size="1"
                  active-color="#ededed"
                  @update:modelValue="loadPage"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
 <consentdocumentupload
      v-if="documentUploadpopup"
      :documentTitle="uploadDocumentTitle"
      :description="uploadDescription"
      :docid="uploadDocId"
      :siteCode="uploadSiteCode"
      @uploadlibactive="handleCloseDocumentUpload"
       @documentUploaded="handleDocumentUploaded"
    />
<ReconsentCampaignmodal 
    v-if="showreconsentcampaignpopup"
    @closeModal="showreconsentcampaignpopup = false"
    :consentRecordId="selectedConsentRecordId"
    :selectedICF="selectedICF"
/>
<ICFVideos
  v-if="showVideosPopup"
  :icfId="selectedVideoIcfId"
  :icfName="selectedVideoIcfName"
  :icfVersion="selectedVideoIcfVersion"
  @close="showVideosPopup = false"
/>
</template>

<script src="./icfListing.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.wrap-table-cell {
  min-width: 70ch;
  text-wrap-mode: wrap;
}

input :disabled {
  cursor: not-allowed;
  opacity: 1;
}

.previousbtn, .nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}

.page-links {
  border-radius: 0px;
}

.form-select {
  border-radius: 0 !important;
}

.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}

.position-relative img {
  width: 20px;
}

.cursor-pointer {
  cursor: pointer;
}

.position-relative {
  position: relative;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.modal__container22 {
  width: 33%;
  max-width: 30%;
  position: fixed;
  height: 20% !important;
  margin-top: -550px !important;
  margin-left: 409px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}

.modal__container23 {
  width: 66%;
  max-width: 62%;
  position: fixed;
  height: -14% !important;
  margin-top: -683px !important;
  margin-left: 140px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}

.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}

.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.audit__details__modal__container {
  width: min(90%, 365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.heightBig {
  overflow-y: scroll;
  height: 250px;
}

.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}

.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000;
}

.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
</style>
